import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * Overdue Tasks list configuration
 * Shows pending tasks past their due date
 */
export const overdueTasksList: ListBuilderList = {
	id: 'overdue-tasks',
	cacheTTL: 300000,
	name: 'Overdue',
	type: 'default',
	active: true,
	sortOrder: 2,
	activeFilters: [
		'taskKeywords',
		'taskPriority',
		'taskAssignedUser',
		'taskClient',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'overdue',
					label: 'Overdue',
					data: {
						startDate: null,
						endDate: '{{NOW}}',
					},
				},
			],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
	},
};
